import React from 'react';
import './ModalVisualizarImagem.scss';

interface Props {
  visible: boolean;
  imagemUrl: string | null;
  imagemNome: string | null;
  imagemTamanho?: string | null;
  onHide: () => void;
  onRemover?: () => void;
}

export default function ModalVisualizarImagem({
  visible,
  imagemUrl,
  imagemNome,
  imagemTamanho,
  onHide,
  onRemover,
}: Props) {
  if (!visible || !imagemUrl) return null;

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onHide();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      onHide();
    }
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <div
      className="modal-visualizar-imagem"
      onClick={handleBackdropClick}
      onKeyDown={handleKeyDown}
      role="dialog"
      aria-modal="true"
      tabIndex={-1}
    >
      <div className="modal-visualizar-imagem__content">
        <button
          type="button"
          className="modal-visualizar-imagem__close"
          onClick={onHide}
        >
          <i className="fas fa-times" />
        </button>
        <img src={imagemUrl} alt={imagemNome || 'Imagem'} />
        <div className="modal-visualizar-imagem__info">
          <span className="modal-visualizar-imagem__nome">
            {imagemNome || 'Sem nome'}
          </span>
          <span className="modal-visualizar-imagem__separator">|</span>
          <span className="modal-visualizar-imagem__tamanho">
            {imagemTamanho || 'Tamanho desconhecido'}
          </span>
          {onRemover && (
            <>
              <span className="modal-visualizar-imagem__separator">|</span>
              <button
                type="button"
                className="modal-visualizar-imagem__remover"
                onClick={onRemover}
              >
                <i className="fas fa-trash" />
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
